import { A11ySettings, useA11y } from "../contexts/A11yProvider";

export function useA11ySettings() {
  const { settings, updateSettings } = useA11y();

  return {
    darkMode: settings.darkMode,
    highContrast: settings.highContrast,
    lowAnimation: settings.lowAnimation,
    dyslexiaFont: settings.dyslexiaFont,
    largeText: settings.largeText,
    language: settings.language,
    toggleDarkMode: () => updateSettings({ darkMode: !settings.darkMode }),
    toggleHighContrast: () => updateSettings({ highContrast: !settings.highContrast }),
    toggleLowAnimation: () => updateSettings({ lowAnimation: !settings.lowAnimation }),
    toggleDyslexiaFont: () => updateSettings({ dyslexiaFont: !settings.dyslexiaFont }),
    toggleLargeText: () => updateSettings({ largeText: !settings.largeText }),
    setLanguage: (language: A11ySettings["language"]) => updateSettings({ language }),
    updateSettings,
    settings,
  };
}
